import type { ReactNode } from 'react'
import { View } from 'react-native'

import { GradientBackground } from '@/src/elements/background'
import type { TPageBackground } from '@/src/general/constants/pageTypes'
import { palette } from '@/src/styles/palette'

type TPageTypeBackgroundProps = {
  background: TPageBackground
}

export const PAGE_BACKGROUND_THEME_COLOR: Record<TPageBackground, string> = {
  gradient: '#FFFFFF',
  'primary-light': palette.amber[50],
  white: '#FFFFFF',
}

/**
 * Solid background that hide the screens beneath.
 */
export const PageTypeBackground = ({ background }: TPageTypeBackgroundProps): ReactNode => {
  if (background === 'primary-light') {
    return <View className="pointer-events-none absolute inset-0 bg-primary-bg-light" />
  }

  return <View className="pointer-events-none absolute inset-0 bg-white" />
}

type TPageTypeScreenBackgroundProps = {
  background: TPageBackground
  children: ReactNode
}
export const PageTypeScreenBackground = ({ background, children }: TPageTypeScreenBackgroundProps): ReactNode => {
  return (
    <View className={`flex-1 overflow-hidden ${background === 'primary-light' ? 'bg-primary-bg-light' : 'bg-white'}`}>
      {background === 'gradient' && (
        <View className="pointer-events-none absolute inset-0 z-0">
          <GradientBackground fixed={false} />
        </View>
      )}
      {/* Keep the same child position across backgrounds: nested navigators must not remount. */}
      {/* relative + zIndex: keep page UI above the wash (required on web stacking). */}
      <View className="relative z-zIndex1 flex-1">{children}</View>
    </View>
  )
}
